<router-outlet
  name="overlay"
  (activate)="onActivate()"
  (deactivate)="onDeactivate()"
></router-outlet>
